// §15 / D-043 — the Windows sound set: brighter and more bell-like than house's warm two-tone,
// and every one of them generated. Nothing here is a file, and nothing is sampled from Windows.
import type { SoundId, SoundRecipe } from '@hangar/shared';

export const windowsSounds: Record<SoundId, SoundRecipe> = {
  // A rising major third — the shape a notification chime has, arrived at from scratch.
  notify: {
    tones: [
      { wave: 'sine', freq: 880, at: 0, duration: 0.09, gain: 0.14, attack: 0.003, release: 0.06 },
      { wave: 'sine', freq: 1108, at: 0.07, duration: 0.14, gain: 0.11, attack: 0.003, release: 0.1 },
    ],
  },
  error: {
    tones: [
      { wave: 'triangle', freq: 415, at: 0, duration: 0.1, gain: 0.17, release: 0.05 },
      { wave: 'triangle', freq: 311, at: 0.09, duration: 0.16, gain: 0.15, release: 0.1 },
    ],
  },
  // §5.4 makes this one audible constantly on this skin, so it is the shortest thing here.
  snap: {
    tones: [{ wave: 'sine', freq: 740, endFreq: 1046, at: 0, duration: 0.05, gain: 0.09, release: 0.03 }],
  },
  trash: {
    tones: [
      { wave: 'sawtooth', freq: 500, endFreq: 160, at: 0, duration: 0.16, gain: 0.08, release: 0.1 },
    ],
  },
  screenshot: {
    tones: [{ wave: 'square', freq: 1600, at: 0, duration: 0.025, gain: 0.06, release: 0.02 }],
  },
  deviceConnect: {
    tones: [
      { wave: 'sine', freq: 659, at: 0, duration: 0.08, gain: 0.11, release: 0.04 },
      { wave: 'sine', freq: 988, at: 0.08, duration: 0.1, gain: 0.11, release: 0.06 },
    ],
  },
  startup: {
    tones: [
      { wave: 'sine', freq: 523, at: 0, duration: 0.18, gain: 0.09, attack: 0.04, release: 0.12 },
      { wave: 'sine', freq: 784, at: 0.12, duration: 0.22, gain: 0.08, attack: 0.04, release: 0.16 },
      { wave: 'sine', freq: 1046, at: 0.24, duration: 0.3, gain: 0.07, attack: 0.04, release: 0.24 },
    ],
  },
};
